import React from 'react';
import {
  Button,
  Card,
  CardHeader
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import housingstore from '../stores/housingstore';

const closeModal = () => {
  housingstore.setOpenModal();
}

const resetForm = () => {
  housingstore.clearHousingAssessmentForm();
  housingstore.setOpenModal();
}

const ErrorWindowComponent = props => {
  const {
    errorCount
  } = props;

  return (
    <>
      <Card>
        <CardHeader className="errorPopup d-flex justify-content-center flex-column align-items-center center-text">
          {
            errorCount > 0 ?
              <>
                <h5>
                  <b>
                    The FCS assessment has failed to send.
                </b>
                </h5>
                {
                  housingstore.requiredDateValidationCheck && (
                    <>
                      <h7>Please Enter all the Required Fields</h7>
                      <h7>Please Enter all the Requried Date Fields using the Date Picker</h7>
                    </>
                  )
                }
                <div className="spacer" />
                <h6>Hit <b>submit</b> again</h6>
                <Button className="errCloseBtn" onClick={() => closeModal()} type="button" color="default">
                  OK
              </Button>
              </>
              :
              <>
                <h5>
                  <b>
                    The FCS assessment has failed to send.
                </b>
                </h5>
                <div className="spacer" />
                <h6>Please try again sometime later.</h6>
                <NavLink exact to="/" onClick={() => resetForm()} className="btn errCloseBtn btn-default">
                  OK
              </NavLink>
              </>
          }
        </CardHeader>
      </Card>
    </>
  )
}

ErrorWindowComponent.propTypes = {
  errorCount: PropTypes.number
}

export default ErrorWindowComponent;